import { Icon } from "../Icon.js";
import deliver_box_default from "../static/deliver-box.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconDeliverBox.tsx
/* istanbul ignore file -- @preserve */
const IconDeliverBox = ({ color, height, style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: deliver_box_default,
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconDeliverBox };